// extracted by mini-css-extract-plugin
module.exports = {"chatModal":"index_chatModal__3Bc6W","friendHomepage":"index_friendHomepage__g00Ba","circleChat":"index_circleChat__s6MZC","callChat":"index_callChat__C8APn"};